(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CommunicationTypeSearch', CommunicationTypeSearch);

    CommunicationTypeSearch.$inject = ['$resource'];

    function CommunicationTypeSearch($resource) {
        var resourceUrl =  'api/_search/communication-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
